import React, { useState, useEffect } from "react";
import useB2BTranslation from "../../../b2b-common/hooks/useB2BTranslation";
import { isEqual } from "lodash";

const PayloadGeneratorFactory = ({ post = null, onPostChange, onPayloadReady }) => {
    const { t } = useB2BTranslation('b2b-social');

    const [GeneratorComponent, setGeneratorComponent] = useState(null);
    const [currentPost, setCurrentPost] = useState(null);

    useEffect(() => {
        const loadComponent = async () => {
            if ((post && post.socialPostTemplate.socialPostTemplateAcronym) && !isEqual(post, currentPost)) {
                setCurrentPost(post);
                try {
                    const component = await import(`./generators/PayloadGenerator_${post.socialPostTemplate.socialPostTemplateAcronym}.js`);
                    setGeneratorComponent(() => component.default);
                } catch (error) {
                    console.error('Error loading component:', error);
                }
            }
        };
        if (!isEqual(post, currentPost)) {
            loadComponent();
        }
    }, [post]);

    if (!GeneratorComponent) {
        return <div>{t('Loading...')}</div>;
    }

    return <GeneratorComponent post={post} onPostChange={onPostChange}  onPayloadReady={onPayloadReady} />;
};

export default PayloadGeneratorFactory;